import { createModule } from '@evyweb/ioctopus';

import { getMarketplaceBalanceUseCase, getRetailerBalanceUseCase } from '../../application/entry.js';
import { marketplaceGroupsServiceClient } from '../../infrastructure/entry.browser.js';
import {
  getMarketplaceBalanceController,
  getRetailerBalanceController,
} from '../../interface-adapters/entry.browser.js';
import { diSymbolMap } from '../types.js';

/**
 * Creates the marketplace groups dependency injection module.
 * Configures bindings for marketplace groups services, use cases, and controllers.
 *
 * @returns The configured marketplace groups DI module
 */
export function createMarketplaceGroupsClientModule(): ReturnType<typeof createModule> {
  const marketplaceGroupsModule = createModule();

  // Services
  marketplaceGroupsModule
    .bind(diSymbolMap.IMarketplaceGroupsService)
    .toHigherOrderFunction(marketplaceGroupsServiceClient);

  // Use cases
  marketplaceGroupsModule
    .bind(diSymbolMap.IGetMarketplaceBalanceUseCase)
    .toHigherOrderFunction(getMarketplaceBalanceUseCase, [diSymbolMap.IMarketplaceGroupsService]);
  marketplaceGroupsModule
    .bind(diSymbolMap.IGetRetailerBalanceUseCase)
    .toHigherOrderFunction(getRetailerBalanceUseCase, [diSymbolMap.IMarketplaceGroupsService]);

  // Controllers
  marketplaceGroupsModule
    .bind(diSymbolMap.IGetMarketplaceBalanceController)
    .toHigherOrderFunction(getMarketplaceBalanceController, [diSymbolMap.IGetMarketplaceBalanceUseCase]);
  marketplaceGroupsModule
    .bind(diSymbolMap.IGetRetailerBalanceController)
    .toHigherOrderFunction(getRetailerBalanceController, [diSymbolMap.IGetRetailerBalanceUseCase]);

  return marketplaceGroupsModule;
}
